export const APV_BASE_URL = '/home/ccv';

export const SHELL_HOME_URL = '/inicio';

export const SHELL_LOGIN_URL = '/login';

export const SHELL_PERSONAL_DATA_URL = '/data-update/home/perfil';

export const SHELL_VIDEO_CALL_URL = '/video-atencion';
